import { Link } from 'react-scroll'
import { NavLink } from 'react-router-dom'
import MobileMenuSec from '../MobileMenu/MobileMenu'
import Logo from '../../images/logo.svg'


const Header = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (

        <header id="header">
            <div className="wpo-site-header wpo-header-style-s3 wpo-header-preview">
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                                <div className="mobail-menu">
                                    <MobileMenuSec />
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-6 col-6">
                                <div className="navbar-header">
                                    <NavLink onClick={ClickHandler} className="navbar-brand" to="/home"><img src={Logo} alt="" /></NavLink>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-1 col-1">
                                <div id="navbar" className="site-navbar collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li><Link activeClass="active" to="demo" spy={true} smooth={true} offset={-100} duration={500} >Demo</Link></li>
                                        <li><Link activeClass="active" to="features" spy={true} smooth={true} offset={-100} duration={500} >Features</Link></li>
                                        <li><a target='_blank' rel="noreferrer" href="https://wpolive.com/docs/bohu/index.html">Documentation</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-2 col-2">
                                <div className="service-btn">
                                    <a href="https://wpocean.com/contact/" rel="noreferrer"  target="_blank" className="shop-btn"><i
                                        className="ti-headphone"></i>
                                        <span>Customer Support</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}
export default Header;